
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdOption } from '@angular/material';

import { ValidationService } from './../../../shared/services/validation.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { PrescriptionModel } from '../../../models/master-data/prescription.model';
import { PrescriptionService } from './prescription.service';
import { DialogService } from '../../../shared/services/dialog.service';

@Component({
    selector: 'modify-prescription-popup',
    templateUrl: 'modify-prescription-popup.component.html',
    providers: [PrescriptionService]
})

export class ModifyPrescriptionComponent implements OnInit {
    title: string;
    modifyPrescriptionForm: FormGroup;
    modifyPrescriptionModel = new PrescriptionModel();
    formMessage = '';
    id: any;
    public defunctData = [];
    public weekQuantityData = [];
    public isSuccess = false;

    centres = JSON.parse(localStorage.getItem(AppConstants.localStorage.centres));
    currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);
    selectAll = {centreId: '00000000-0000-0000-0000-000000000000', centreName: 'Apply to all'}
    @ViewChild('allSelected') public allSelected: MdOption;

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        public dialogRef: MdDialogRef<ModifyPrescriptionComponent>,
        public dialogService: DialogService,
        private prescriptionService: PrescriptionService,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
        this.id = this.data.id;
        if (this.id) {
            this.getPrescription(this.id);
            this.modifyPrescriptionModel.id = this.id;
            this.title = 'Update Prescription';
        } else {
            this.title = 'Add New Prescription';
            this.modifyPrescriptionForm.controls['prescriptionCategoryId'].setValue(this.data.categoryId);
            this.modifyPrescriptionModel.prescriptionCategoryName = this.data.categoryName;
            this.modifyPrescriptionModel.centreIds = [this.currentCentreId];
        }
        this.defunctData = this.prescriptionService.getDefunctData();
        this.weekQuantityData = this.prescriptionService.getWeekQuantityData();

    }

    createForm() {
        this.modifyPrescriptionForm = this.formBuilder.group({
            prescriptionCategoryId: [''],
            prescriptionCategoryName: [''],
            prescriptionName: ['', [Validators.required]],
            description: [''],
            brandName: [''],
            sig: ['', [Validators.required]],
            note: [''],
            defaultDose: ['', [Validators.required]],
            weekQuantity: [0, [Validators.required]],
            defunct: ['', [Validators.required]],
            priority: [0, [ValidationService.isValidNumber0To999]],
            centreIds: ['', [Validators.required]],
            prescriptionId: ['']
        });
    }

    tosslePerOne() {
      if (this.allSelected.selected) {
        this.allSelected.deselect();
        let updatedValues = this.modifyPrescriptionForm.controls.centreIds.value.filter(value => value !== this.selectAll.centreId);
        this.modifyPrescriptionForm.controls.centreIds.setValue(updatedValues);
        return false;
      }
      if (this.modifyPrescriptionForm.controls.centreIds.value.length == this.centres.length)
      {
        this.allSelected.select();
        let currentValues = this.modifyPrescriptionForm.controls.centreIds.value;
        let updatedValues = [...currentValues, this.selectAll.centreId];
        this.modifyPrescriptionForm.controls.centreIds.setValue(updatedValues);
      }
    }
    toggleAllSelection() {
      if (this.allSelected.selected) {
          this.modifyPrescriptionForm.controls.centreIds.patchValue([...this.centres.map(item => item.centreId), this.selectAll.centreId]);
        } else {
            this.modifyPrescriptionForm.controls.centreIds.patchValue([]);
        }
      }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    getPrescription(id) {
        this.prescriptionService.getPrescription(id).subscribe(
            (result) => {
                const data = result.json();
                this.modifyPrescriptionModel = data;
                if(this.modifyPrescriptionModel.defunct === false){
                    this.modifyPrescriptionModel.defunct = 0;
                }else{this.modifyPrescriptionModel.defunct = 1;}
                this.modifyPrescriptionModel.centreIds = [this.currentCentreId];
            }, (error) => { }
        );
    }

    editPrescription() {
        this.modifyPrescriptionForm.controls['prescriptionCategoryId'].setValue(this.data.categoryId);
        if(this.modifyPrescriptionForm.controls['defunct'].value == '1'){
            this.modifyPrescriptionForm.controls['defunct'].setValue(true);
        }else{
            this.modifyPrescriptionForm.controls['defunct'].setValue(false);
        }
        this.prescriptionService.updatePrescription(this.data.id, this.modifyPrescriptionForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        );
    }
    addPrescription(){
        this.modifyPrescriptionForm.controls['prescriptionCategoryId'].setValue(this.data.categoryId);
        this.prescriptionService.addPrescription(this.modifyPrescriptionForm.value).subscribe(
            result=>{
                if(result){
                    const data = result.json();
                    this.dialogService.openSuccessDialog({message : data.message});
                    this.isSuccess = true;
                    this.close();
                }
            }
        );
    }
    onSubmit() {
        if (this.modifyPrescriptionForm.valid) {
            if (this.id) {
                this.editPrescription();
            } else {
                this.addPrescription();
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/presciption/modify-prescription-popup.component.ts